// extracted by mini-css-extract-plugin
export default {"PasswordForgot":"PasswordForgot_PasswordForgot__gg8kh","PasswordForgotBox":"PasswordForgot_PasswordForgotBox__NmztQ"};